import { NgModule } from '@angular/core';
import { CsAvatarComponent } from '../cs-avatar/cs-avatar.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';

import { FileDocumentQueryComponent } from './file-document-query.component';
import { MyMaterialModule } from 'src/app/app.material';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { HelpStepperModule } from '../help-stepper/help-stepper.module';
import { GenericBottomsheetModule } from '../generic-bottom-sheet/generic-bottom-sheet.module';
import { CertificateDeclarationModule } from '../certificate-declaration/certificate-declaration.module';
import { TranslocoModule } from '@ngneat/transloco';

@NgModule({
  declarations: [
    FileDocumentQueryComponent
  ],
  imports: [
    CommonModule,
    MatIconModule,
    MyMaterialModule,
    FormsModule,
    FlexLayoutModule,
    HelpStepperModule,
    GenericBottomsheetModule,
    CertificateDeclarationModule,
    TranslocoModule,
    CsAvatarComponent
  ],
  providers: [],
  exports: [
    FileDocumentQueryComponent
  ]
})
export class FileDocumentQueryModule { }



